import styled from '@emotion/styled';
import { MastheadWrapper } from '@zola/zola-ui/src/components/PreAuthV3/Masthead.styles';

import PageWrapper from './PageWrapper.styles';

export const PaperInvitesPageWrapper = styled(PageWrapper)`
  // Masthead fixes
  ${MastheadWrapper} {
    height: auto;
  }
`;
